/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {forwardRef} from 'react';
import {defineMessages} from 'react-intl';
import {Link} from 'react-router-dom';
import {Button} from 'react-bootstrap';
import {useFormatMessage} from 'app/hooks';
import UpIcon from 'icons/UpIcon';

const messages = defineMessages({
  title: {id: 'label.button.move-up', defaultMessage: 'Move Up'},
});

const MoveUpIconButton = (
  {variant = 'light', title = messages.title, href, ...props},
  ref
) => {
  const titleText = useFormatMessage(title, title.values);
  if (href) {
    return (
      <Button
        ref={ref}
        as={Link}
        to={href}
        variant={variant}
        title={titleText}
        {...props}
      >
        <UpIcon />
      </Button>
    );
  }
  return (
    <Button ref={ref} variant={variant} title={titleText} {...props}>
      <UpIcon />
    </Button>
  );
};
MoveUpIconButton.displayName = 'MoveUpIconButton';

export default forwardRef(MoveUpIconButton);
